import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import { Button, Modal, Select } from "../../../components/core";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import {
	LOCKER_TYPES_FOR_STORAGE_TIME_LIMITS,
	STORAGE_TIME_LIMITS,
	UPDATE_STORAGE_TIME_LIMITS,
} from "../../../constants/graphql/storage-time-limits-query";
import {
	changeCriteriaValue,
	changeStorageTimeLimitsData,
	clearStorageTimeFeeChanges,
	getLockerTypeList,
	setStorageTimeLimitsData,
} from "../../../features/storage-time-limits/storage-time-limits-slice";
import StorageTimeLimitTable from "./components/storage-time-limit-table";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import useSidebarStore from "../../../zustand/stores/sidebar-store";
import { Strings } from "../../../constants/strings";

export default function StorageTimeLimits() {
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	// Utilities
	const dispatch = useDispatch();
	const navigate = useNavigate();
	//Redux States
	const searchCriteria = useSelector(
		(state) => state.storageTimeLimits.searchCriteria
	);
	const [editingDone, setEditingDone] = useState(false);
	const lockerTypeList = useSelector(
		(state) => state.storageTimeLimits.lockerTypeList
	);
	const storageTimeLimitsData = useSelector(
		(state) => state.storageTimeLimits.storageTimeLimitsData
	);
	//Graphql
	const lockerTypes = useQuery(LOCKER_TYPES_FOR_STORAGE_TIME_LIMITS);
	const [storageTimeLimits, { refetch }] = useLazyQuery(STORAGE_TIME_LIMITS, {
		fetchPolicy: "no-cache",
	});
	const [updateStorageTimeLimits] = useMutation(UPDATE_STORAGE_TIME_LIMITS);
	//Local States
	const [initialStorageTimeLimit, setInitialStorageTimeLimit] = React.useState(
		{}
	);
	const [searchFlag, setSearchFlag] = React.useState(false);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const [valueChanged, setValueChanged] = useState(false);
	const [success, setIsSuccess] = useState(false);
	const [currentLockerType, setCurrentLockerType] = React.useState("");
	//Handle Changes
	// const handleChangeCriteriaValue = (event) => {
	// 	const { name, value } = event.target;
	// 	dispatch(changeCriteriaValue({ name: name, value: value }));
	// };
	// zustand
	const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
	const setPendingNavigation = useSidebarStore(
		(state) => state.setPendingNavigation
	);
	const activeSubItem = useSidebarStore((state) => state.activeSubItem);
	const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

	const handleSearchStorageTimeLimits = (event) => {
		setEditingDone(false);
		const { name, value } = event.target;
		dispatch(changeCriteriaValue({ name: name, value: value }));
		if (event.target.value === "-1" && event.target.name === "lockerTypeId") {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete search criteria",
				message: "Please input Locker Type.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else {
			setCurrentLockerType(
				lockerTypeList.find((x) => x.value === event.target.value).name
			);
			setSearchFlag(true);
			let tempSearchCriteria = { ...searchCriteria };
			tempSearchCriteria.lockerTypeId = event.target.value;
			console.log(tempSearchCriteria);
			storageTimeLimits({ variables: tempSearchCriteria })
				.then((data) => {
					if (data.data) {
						setInitialStorageTimeLimit(data.data.lockerLimit[0]);
						dispatch(setStorageTimeLimitsData(data.data.lockerLimit[0]));
						console.log(data.data.lockerLimit[0]);
					}
				})
				.catch((e) => console.log(e));
		}
	};
	console.log({ editingDone });
	const handleChangeStorageTimeLimits = (event) => {
		setEditingDone(true);
		setIsSuccess(false);
		const { name, value } = event.target;

		dispatch(changeStorageTimeLimitsData({ name: name, value: value }));
	};
	const handleSaveChanges = () => {
		if (
			storageTimeLimitsData.storageTakebackLimit === "" ||
			storageTimeLimitsData.storagePulloutLimit === ""
		) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Empty field error",
				message: "All fields are required.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		}

		if (
			storageTimeLimitsData.storageTakebackLimit > 720 ||
			storageTimeLimitsData.storagePulloutLimit > 720
		) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Value",
				message: "Maximum hour is 720. Please recheck.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else {
			let tempStorageTimeLimitsData = { ...storageTimeLimitsData };

			delete tempStorageTimeLimitsData.__typename;

			tempStorageTimeLimitsData.operatorId = searchCriteria.operatorId;
			tempStorageTimeLimitsData.lockerTypeId = searchCriteria.lockerTypeId;
			updateStorageTimeLimits({ variables: tempStorageTimeLimitsData })
				.then((data) => {
					setValidation({
						icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
						title: "Success",
						message: "Successfully modified storage time limits.",
						open: true,
						actions: (
							<div className="grid grid-cols-1">
								<Button
									onClick={() => {
										setValidation({ open: false });
										setIsSuccess(true);
										setEditingDone(false);
										refetch();
									}}
									value={"OK"}
									className={"p-2"}
								/>
							</div>
						),
					});
					setInitialStorageTimeLimit(tempStorageTimeLimitsData);
					dispatch(setStorageTimeLimitsData(tempStorageTimeLimitsData));
				})
				.catch((e) => console.log(e));
		}
	};
	const handleCancelChanges = () => {
		setValidation({
			open: false,
		});
		setEditingDone(false);
		dispatch(clearStorageTimeFeeChanges(initialStorageTimeLimit));
	};
	//Use effects
	React.useEffect(() => {
		if (lockerTypes.data) {
			let tempData = [];
			lockerTypes.data.lockerTypes.forEach((element) => {
				tempData.push({
					value: element.lockerTypeId,
					name: element.lockerType,
				});
			});
			dispatch(getLockerTypeList(tempData));
		}
	}, [lockerTypes.data]);

	useEffect(() => {
		if (pendingNavigation !== null) {
			if (editingDone) {
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: `${Strings.popup_confirm_cancel_title}?`,
					message: Strings.popup_confirm_cancel_massage,
					open: true,
					actions: (
						<div className="flex justify-between gap-3">
							<Button
								onClick={() => {
									setValidation({ open: false });
									// window.location.reload();
									setPendingNavigation(null);
									setActiveSubItem(activeSubItem);
								}}
								value={"No"}
								className={"p-2 w-full"}
							/>
							<Button
								onClick={() => {
									navigate(pendingNavigation);
									setPendingNavigation(null);
								}}
								value={"Yes"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
			} else {
				navigate(pendingNavigation);
				setPendingNavigation(null);
			}
		}
	}, [pendingNavigation, editingDone]);

	return (
		<ContentContainer containerTitle={"Storage Time Limits"}>
			<div className="grid grid-cols-4 gap-2 w-2/3">
				<p className="my-auto">Locker Type:</p>
				<Select
					className={"col-span-3"}
					items={lockerTypeList}
					name="lockerTypeId"
					onChange={handleSearchStorageTimeLimits}
					defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
				/>
				{/* <Button
					className={"p-2"}
					value={"Search"}
					onClick={handleSearchStorageTimeLimits}
				/> */}
			</div>
			{searchFlag === true && (
				<>
					<Card className="bg-primary-primaryYellowLight mt-4">
						<div className="mt-4 bg-[#F8FAFC] w-full p-4 rounded-sm">
							<p className="font-bold text-center">
								{currentLockerType} Locker
							</p>
							<p className="font-bold text-center">MAX LIMIT OF HOURS</p>
							<p className="text-center">(from time package is in locker)</p>
							<p>
								* All time limits are computed from time of Storage in Locker
							</p>

							<StorageTimeLimitTable
								disabled={
									accessPermission.storageTimeLimits === 1 ||
									accessPermission.storageTimeLimits == "1"
								}
								isSuccess={success}
								valueChanged={valueChanged}
								editingDone={editingDone}
								setEditingDone={setEditingDone}
								data={storageTimeLimitsData}
								handleChange={handleChangeStorageTimeLimits}
							/>

							<div className="w-full grid grid-cols-2 gap-4 my-4">
								<Button
									disabled={
										accessPermission.storageTimeLimits === 1 ||
										accessPermission.storageTimeLimits == "1"
									}
									className={`p-2 ${editingDone ? "" : "hidden"}`}
									value="Cancel"
									onClick={() => {
										setValidation({
											icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
											title: "Cancel changes",
											message: "Are you sure you want to cancel changes?",
											open: true,
											actions: (
												<div className="grid grid-cols-2 gap-2">
													<Button
														onClick={() => setValidation({ open: false })}
														value={"No"}
														className={"p-2"}
													/>
													<Button
														onClick={handleCancelChanges}
														value={"Yes"}
														className={"p-2"}
													/>
												</div>
											),
										});
									}}
								/>
								<Button
									className={`p-2 ${editingDone ? "" : "hidden"}`}
									disabled={
										accessPermission.storageTimeLimits === 1 ||
										accessPermission.storageTimeLimits == "1"
									}
									value="Save Changes"
									onClick={() => {
										setValidation({
											icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
											title: "Save changes",
											message: "Are you sure you want to save changes?",
											open: true,
											actions: (
												<div className="grid grid-cols-2 gap-2">
													<Button
														onClick={() => setValidation({ open: false })}
														value={"No"}
														className={"p-2"}
													/>
													<Button
														onClick={handleSaveChanges}
														value={"Yes"}
														className={"p-2"}
													/>
												</div>
											),
										});
									}}
								/>
							</div>
						</div>
					</Card>
				</>
			)}
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</ContentContainer>
	);
}
